exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".container-1cb7aa75{width:100%;padding:30px 40px 40px 40px;display:flex}.mainColumn-5d054b61{flex:1;min-width:0px;margin-right:40px}.sideColumn-f052a185{width:280px;flex:0 0 280px}.editorColumn-1696b792{flex:1;min-width:0px;height:100%}\n", ""]);

// Exports
exports.locals = {
	"container": "container-1cb7aa75",
	"mainColumn": "mainColumn-5d054b61",
	"sideColumn": "sideColumn-f052a185",
	"editorColumn": "editorColumn-1696b792"
};